import React from 'react';
import { twMerge } from 'tailwind-merge';

interface MarqueeProps {
  children: React.ReactNode;
  className?: string;
  reverse?: boolean;
  pauseOnHover?: boolean;
  speed?: number;
  dark?: boolean;
}

export default function Marquee({
  children,
  className,
  reverse = false,
  pauseOnHover = true,
  speed = 30,
  dark = true,
}: MarqueeProps) {
  const fadeFrom = dark ? 'from-dark' : 'from-surface';

  return (
    <div
      className={twMerge('overflow-hidden relative', className)}
    >
      {/* Fade edges */}
      <div className={`absolute left-0 top-0 bottom-0 w-20 bg-gradient-to-r ${fadeFrom} to-transparent z-10 pointer-events-none`} />
      <div className={`absolute right-0 top-0 bottom-0 w-20 bg-gradient-to-l ${fadeFrom} to-transparent z-10 pointer-events-none`} />

      <div
        className={twMerge(
          'flex gap-6 w-max',
          reverse ? 'animate-marquee-reverse' : 'animate-marquee',
          pauseOnHover && 'hover:[animation-play-state:paused]'
        )}
        style={{ animationDuration: `${speed}s` }}
      >
        {children}
        {children}
      </div>
    </div>
  );
}
